module.exports = __webpack_public_path__ + "static/media/platform2.31c00684.png";